module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("Prelude")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Apart from the 1929 Cole Porter song, this is a ridiculous title and I know it; sounds a little like some egotistical guru telling the rest of the world about love and lovemaking and broken hearts—as if most people didn’t already know these things from their own experiences. And yet . . . some of the desperately romantic situations I’ve known, plus a few touching and sometimes comical situations I’ve heard from others, might give you a little plea sure and a laugh. If they do, I’ll be happy.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—GENE WILDER")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ca71eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prelude.vue
// module id = 78
// module chunks = 0